<button
  mat-button
  class="profile-menu"
  [attr.aria-label]="'Profile menu for ' + (userProfileData?.profileDetails?.firstName || 'user')"
  [matMenuTriggerFor]="userProfileMenu"
  #menuTrigger="matMenuTrigger"
>
  <mds-profile-dropdown-avatar
    [matMenuTriggerFor]="userProfileMenu"
    [firstName]="userProfileData?.profileDetails?.firstName"
    [lastName]="userProfileData?.profileDetails?.lastName"
    [email]="userProfileData?.profileDetails?.email"
    [avatar]="userProfileData?.profileDetails?.avatar"
    [attr.data-testid]="'userProfileMenu'"
  ></mds-profile-dropdown-avatar>
</button>

<mat-menu #userProfileMenu="matMenu" class="mat-drawer-menu user-profile-menu">
  <mds-user-profile-menu
    (onClickAction)="menuClickAction($event)"
    [profileMenu]="userProfileData">
  </mds-user-profile-menu>
</mat-menu>
